import { Swiper } from 'swiper';
import 'swiper/css';

export default function latestPublications() {
    let swiper;

    if (document.querySelector('.latest-publications__posts')) {
        if (window.innerWidth < 1024) {
            swiper = initSwiper();
        }
    }

    window.addEventListener('resize', () => {
        if (window.innerWidth < 1024) {
            if (!swiper) {
                swiper = initSwiper();
            }
        } else {
            if (swiper) {
                swiper.destroy();
                swiper = null;
            }
        }
    });
}

const initSwiper = () => {
    const swiperArgs = {
        slidesPerView: 1.2,
        spaceBetween: 24,
        enabled: true,
        grabCursor: true,
        breakpoints: {
            540: {
                enabled: true,
                slidesPerView: 1.4,
                spaceBetween: 24,
            },
            768: {
                enabled: true,
                slidesPerView: 2.1,
                spaceBetween: 24,
            },
            1024: {
                enabled: false,
                slidesPerView: 2,
                spaceBetween: 24,
            },
        },
    };

    if (document.querySelectorAll('.latest-publications__posts .card-publication').length === 1) {
        swiperArgs.slidesPerView = 1;
        swiperArgs.spaceBetween = 0;
        swiperArgs.enabled = false;
        swiperArgs.breakpoints = {};
    }

    return new Swiper('.latest-publications__posts', swiperArgs);
};
